import React from 'react';
import Drawer from "@material-ui/core/Drawer";
import classNames from 'classnames';
import {withStyles} from "@material-ui/core/styles";

const drawerWidth = 460;
const drawerCollapsedWidth = 56;
const largeWidth = 1024; // >=largeWidth: show drawer by default;
const smallWidth = 512;

const hideButtonHeight = '45px';

// const ScreenSizeContext = React.createContext({ screenSize: 'large', collapsed: 'false' });

const styles = theme => ({
	drawer: {
		position: 'relative',
		zIndex: 1000,
	},
	drawerPaper: {
		maxHeight: '100%',
		borderTopLeftRadius: '0px',
		borderBottomLeftRadius: '0px',
		whiteSpace: 'nowrap',
		overflowX: 'hidden',
		width: drawerWidth,
		position: 'relative'
	},
	drawerPaperHidden: {
		position: 'fixed',
		height: `calc(${hideButtonHeight})`,
		transition: theme.transitions.create('height', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.short,
		}),
	},
	drawerPaperHiddenPadded: {
		position: 'fixed',
		height: `calc(${theme.mixins.toolbar} + ${hideButtonHeight})`,
		transition: theme.transitions.create('height', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.short,
		}),
	},
	drawerPaperSmallScreen: {
	},
	drawerPaperExpanded: {
		width: drawerWidth,
		transition: theme.transitions.create(['width', 'height'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.short,
		}),
	},
	drawerPaperCollapsed: {
		transition: theme.transitions.create(['width', 'height'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.short,
		}),
		width: drawerCollapsedWidth + 1,
		[theme.breakpoints.up('sm')]: {
			width: drawerCollapsedWidth + 1,
		},
	},
	toolbar: theme.mixins.toolbar,
	toggleButton: {
		position: 'absolute',
		bottom: '0px',
		width: drawerWidth,
	},
});

const RightSideDrawer = (props) => {
	const { classes, children, padding } = props;
	const padded = padding ? <div className={classes.toolbar} /> : null;
	return (
		<Drawer
			variant="permanent"
			anchor={"right"}
			open={true}
			className={classNames(classes.drawerPaper, classes.drawer)}
			classes={{
				paper: classNames(classes.drawerPaper),
			}}
		>
			{padded}
			{children}
		</Drawer>
	);
};

export default withStyles(styles)(RightSideDrawer);